import styled from 'styled-components'

export const FooterAcoes = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

/** Largura fixa da coluna de análises; a coluna do formulário ocupa o resto (1fr). */
const LARGURA_COLUNA_ANALISES = 540

/**
 * Ocupa toda a altura útil do corpo da gaveta (que é flex column com overflow hidden),
 * para que cada coluna tenha o próprio scroll em vez de um scroll único para as duas.
 */
export const ConteudoGrid = styled.div`
  display: grid;
  /* Fixo na direita em vez de 1fr 1fr: a grade de pontos das análises tem largura
     de chip fixa, então esticar/encolher a coluna só mudava a quebra de linha. */
  grid-template-columns: minmax(0, 1fr) ${LARGURA_COLUNA_ANALISES}px;
  gap: 16px;
  align-items: stretch;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  /* Cada coluna se vira com a própria altura; min-height 0 evita estourar a grid. */
  > * {
    min-height: 0;
  }
`

/** Coluna do formulário: rola independente da coluna de análises. */
export const ColunaEsquerda = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Espaço para a barra de rolagem não cobrir o conteúdo. */
  padding-right: 6px;

  /* Como a coluna agora tem altura limitada, os filhos precisam manter o
     tamanho natural e transbordar para o scroll — sem isso o flex encolhe
     os itens de menor altura (ex.: o Collapse "Detalhes do cliente" some). */
  > * {
    flex-shrink: 0;
  }
`
